(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class GinkgoStickyHeader extends HTMLElement {

    constructor() {

      super();

      this.setHeaderHeight = this.setHeaderHeight.bind(this);

    }

    connectedCallback() {

      this.header = this;

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.headerIsAlwaysSticky =

        this.getAttribute('data-sticky-type') === 'always' ||

        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

    }

    setHeaderHeight() {

      document.documentElement.style.setProperty(

        '--header-height',

        `${this.header.offsetHeight}px`

      );

    }

    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener(

        'change',

        this.setHeaderHeight

      );

      window.removeEventListener(

        'scroll',

        this.onScrollHandler

      );

    }

    onScroll() {

      const scrollTop =

        window.pageYOffset ||

        document.documentElement.scrollTop;

      if (

        scrollTop > this.currentScrollTop &&

        scrollTop > this.offsetHeight

      ) {

        if (this.headerIsAlwaysSticky) return;

        this.classList.add('gk-header-hidden');

      } else if (scrollTop < this.currentScrollTop) {

        this.classList.remove('gk-header-hidden');

      }

      if (scrollTop <= 10) {

        this.classList.remove('gk-header-hidden');

      }

      this.currentScrollTop = scrollTop;

    }

  }

  if (!customElements.get('sticky-header')) {

    customElements.define('sticky-header', GinkgoStickyHeader);

  }


  } catch(e) { console.error(e); }
})();
})();
